import types from '../../actions/types';
import {multipleResultReducer} from '../common/multiple-results';
import {singleResultInitialState, singleResultReducer} from '../common/single-result';

const initial_state = {
    participant_results: [],
    participant_result: singleResultInitialState,
    loading: false
};

export default function (state = initial_state, action) {
    switch (action.type) {
        default:
            return {
                ...state,
                participant_results: multipleResultReducer(state.participant_results, types.SUBMIT_ADMIN_PARTICIPANT_RESULT_SEARCH, action),
                participant_result: singleResultReducer(state.participant_result, types.LOAD_PARTICIPANT_RESULT, action)
            };

    }
}



// WEBPACK FOOTER //
// ./src/js/reducers/admin/participant.js